export function getOfferTypeName(keyName) {
  switch (keyName) {
    case 'offer_sales':
      return 'general'
    case 'percentage_offer_sales':
      return 'percentage'
    case 'dynamic_pricing_percentage':
      return 'dynamic_pricing_percentage'
    case 'dynamic_pricing_percentage_offer_sales':
      return 'dynamic_pricing_percentage'
    case 'takepay_offer_sales':
      return 'takepay'
    case 'combo_offer_sales':
      return 'combo'
    case 'cashback_percentage_offer_sales':
      return 'cashback_percentage'
    case 'cashback_absolute_offer_sales':
      return 'cashback_absolute'
    case 'points_offer_sales':
      return 'points'
    case 'next_buy_cashback_offer_sales':
      return 'nextbuycashback'
    case 'dynamic_rule_offer_sales':
      return 'dynamic_rule'
    case 'cross_sell_offer_sales':
      return 'crosssell'
    case 'benefits_offer_sales':
      return 'benefits'
    default:
      return ''
  }
}
